import React, { useEffect } from "react";
import { Table, Card, CardBody, CardHeader, Input, Label, Button,columns } from "reactstrap";
import { FaExclamationTriangle,FaRegSadCry } from 'react-icons/fa'; 
import Loader from "../../../../../components/common/Loader";

const AdsTable = ({ newButtonLabel, toggleModal, exportPlans, loading, error }) => {

    const renderStatus = (status) => {
        switch (status) {
            case 'SUCCEEDED':
                return (
                    <div className="text-success">
                        <i className="ri-checkbox-circle-line fs-17 align-middle"></i> Success
                    </div>
                );
            case 'FAILED':
                return (
                    <div className="text-danger">
                        <i className="ri-close-circle-line fs-17 align-middle"></i> Failed
                    </div>
                );
            case 'CALCULATING':    
            case 'SCHEDULED':
                return (
                    <div className="text-secondary">
                        <i className="ri-refresh-line fs-17 align-middle"></i> Calculating
                    </div>
                );
            default:
                return (
                    <div className="text-muted">
                        <FaExclamationTriangle className="me-1" /> Unknown
                    </div>
                );
        }
    };

    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    return (
        <div className="table-responsive table-card">
            <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    <h4 className="card-title">Advertisement List</h4>
                    <Button color="primary" onClick={toggleModal}>
                        {newButtonLabel}
                    </Button>
                </CardHeader>
                <CardBody>
                    {loading ? (
                           <div className="text-center">
                           <Loader />
                         </div>
                    ) : error ? (
                        <p>Error loading export plans: {error}</p>
                    ) : (
                        <Table className="align-middle table-nowrap mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col" style={{ width: "46px" }}>
                                        <div className="form-check">
                                            <Input className="form-check-input" type="checkbox" id="cardtableCheckAll" />
                                            <Label className="form-check-label" htmlFor="cardtableCheckAll"></Label>
                                        </div>
                                    </th>
                                    <th scope="col">ID</th> {/* Added ID column */}
                                    <th scope="col">Audience Name</th>
                                    <th scope="col">Created Time</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {exportPlans && exportPlans.length > 0 ? (
                                    exportPlans.map((plan) => (
                                        <tr key={plan.exportPlanId}>
                                            <td>
                                                <div className="form-check">
                                                    <Input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`cardtableCheck${plan.exportPlanId}`}
                                                    />
                                                    <Label
                                                        className="form-check-label"
                                                        htmlFor={`cardtableCheck${plan.exportPlanId}`}
                                                    ></Label>
                                                </div>
                                            </td>

                                            <td><a href="#" className="fw-medium">#Export - {plan.exportPlanId}</a></td>
                                            <td>{plan.audienceName}</td>
                                            <td>{formatDate(plan.createdTime)}</td>
                                            <td> {renderStatus(plan.status)}</td>
                                        </tr>
                                    ))
                                ) : (
<tr>
    <td colSpan="5" className="text-center" style={{ height: '300px', verticalAlign: 'middle' }}>
        <FaRegSadCry size={50} color="gray" />
        <h4 className="mt-3">No Data Available</h4>
        <p className="text-muted">
            It seems like there is no data available at the moment. Please create your first entry to get started.
        </p>
    </td>
</tr>

                                
                                )}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        </div>
    );
};

export default AdsTable;
